export const calculateTotalPrice = (item) => {
  if (!item.quantity && !item.price) return 0;

  return item.quantity * item.price;
};
